import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function AsteriskIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m9.582 23.902.45-8.351-7.005 4.582-2.445-4.219 7.48-3.77L.582 8.38l2.445-4.277 7.004 4.585L9.582.332h4.863l-.449 8.355L21 4.103l2.445 4.277-7.453 3.766 7.453 3.77L21 20.132l-7.004-4.582.45 8.351z" />
    </Icon>
  );
}

AsteriskIcon.displayName = 'AsteriskIcon';
